import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import healthService from '../../services/healthService';

const initialState = {
  scores: [],
  alerts: [],
  selectedPlatform: null,
  selectedConnectionId: null,
  isLoading: false,
  error: null,
};

export const fetchHealthScores = createAsyncThunk(
  'health/fetchScores',
  async (_, { rejectWithValue }) => {
    try {
      const data = await healthService.getHealthScores();
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch health scores');
    }
  }
);

export const fetchAlerts = createAsyncThunk(
  'health/fetchAlerts',
  async (_, { rejectWithValue }) => {
    try {
      const data = await healthService.getAlerts();
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch alerts');
    }
  }
);

export const acknowledgeAlert = createAsyncThunk(
  'health/acknowledgeAlert',
  async (alertId, { rejectWithValue }) => {
    try {
      await healthService.acknowledgeAlert(alertId);
      return alertId;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to acknowledge alert');
    }
  }
);

const healthSlice = createSlice({
  name: 'health',
  initialState,
  reducers: {
    setSelectedPlatform: (state, action) => {
      state.selectedPlatform = action.payload;
    },
    setSelectedConnectionId: (state, action) => {
      state.selectedConnectionId = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHealthScores.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchHealthScores.fulfilled, (state, action) => {
        state.isLoading = false;
        state.scores = action.payload || [];
      })
      .addCase(fetchHealthScores.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchAlerts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAlerts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.alerts = action.payload || [];
      })
      .addCase(fetchAlerts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(acknowledgeAlert.fulfilled, (state, action) => {
        state.alerts = state.alerts.filter((alert) => alert.id !== action.payload);
      });
  },
});

export const { setSelectedPlatform, setSelectedConnectionId, clearError } = healthSlice.actions;
export default healthSlice.reducer;
